import React from 'react';
import {ChipGroupProps} from './ChipGroup.types.web';
import Chip from '../Chip/Chip.web';
import {styles} from './styles.web';

const ChipGroup = (props: React.PropsWithChildren<ChipGroupProps>) => {
  // Props
  const {id, className, list} = props;

  return list && list?.length ? (
    <div id={id} className={className} style={{...styles().chipGroupContainer}}>
      {list?.map((chip, index) => (
        <Chip key={'chip_' + index} {...chip} />
      ))}
    </div>
  ) : null;
};

export default ChipGroup;
